var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgThemeSelector(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;stroke:#707070;stroke-dasharray:5;}.b{clip-path:url(#a);}.c{fill:#10002e;stroke:#000;stroke-miterlimit:10;stroke-width:0.003px;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "a",
    cx: 12.5,
    cy: 12.5,
    r: 12.5
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "b"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(6.071 6.06)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M13.458,10.194a.352.352,0,0,1,0,.5L8.227,15.916A.352.352,0,0,1,8.105,16L4.973,17.208a.352.352,0,0,1-.455-.455L5.73,13.62A.352.352,0,0,1,5.81,13.5l5.23-5.224a.352.352,0,0,1,.5.5l-5.17,5.172-.9,2.322,2.32-.9,5.173-5.173a.352.352,0,0,1,.5,0Zm3.268-2.77L15.074,9.076l.868.868a.352.352,0,1,1-.5.5L14.328,9.326,12.409,7.4,11.292,6.288a.352.352,0,1,1,.5-.5l.868.868,1.652-1.652a1.709,1.709,0,0,1,2.417,0h0a1.709,1.709,0,0,1,0,2.417Zm-.2-1.209a1.006,1.006,0,0,0-1.717-.7L13.149,7.156l1.427,1.427,1.652-1.652A1,1,0,0,0,16.524,6.214Z",
    transform: "translate(-4.493 -4.506)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgThemeSelector);
export default __webpack_public_path__ + "static/media/themeSelector.ec5ec245.svg";
export { ForwardRef as ReactComponent };